import { render, staticRenderFns } from "./AcceptOrRefuseButton.vue?vue&type=template&id=48638ab3&scoped=true&"
import script from "./AcceptOrRefuseButton.vue?vue&type=script&lang=js&"
export * from "./AcceptOrRefuseButton.vue?vue&type=script&lang=js&"
import style0 from "./AcceptOrRefuseButton.vue?vue&type=style&index=0&id=48638ab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48638ab3",
  null
  
)

export default component.exports